import { StyleSheet, Text, View } from 'react-native'
import { ThemedText, ThemedView } from '@app/theme'
import SuccessIcon from '../../../../assets/Icons/SuccessIcon'
import Button from '@app/sharedComponents/Button/Button'
import WhatsAppIcon from '../../../../assets/Icons/Whatsapp';


const RedirectionJourneyModal = ({onWhatsapp, onContactUs}: {onWhatsapp: () => void, onContactUs: () => void}) => {
    return (
        <ThemedView bg='bg-surface-primary' pt='2xl' padding='lg' alignItems='center' justifyContent='center'>
            <SuccessIcon />
            <ThemedText mt='2xl' variant='h5s' color='text-primary'>Volt app link sent on Whatsapp!</ThemedText>
            <ThemedText mt='sm' mb='lg' textAlign='center' variant='b3r' color='text-secondary'>Download Volt through the link and complete your loan application in 5 mins!</ThemedText>
            <Button
                label='Open WhatsApp'
                handlePress={onWhatsapp}
                rightAccessory={() => <WhatsAppIcon />}
                showRightAccessory={true}
            />
            <ThemedView mt='lg' flexDirection='row' alignItems='center' justifyContent='center'>
                <ThemedText variant='b3r' color='text-primary'>Need help?</ThemedText>
                <ThemedText variant='b3s' color='text-action-primary' ml='sm' onPress={onContactUs}>Contact us</ThemedText>
            </ThemedView>
        </ThemedView>
    )
}

export default RedirectionJourneyModal

const styles = StyleSheet.create({})